document.addEventListener('DOMContentLoaded', function () {
  // --- SVG icons ---
  const svgPause = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" width="22" height="22"><path stroke-linecap="round" stroke-linejoin="round" d="M14.25 9v6m-4.5 0V9M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" /></svg>`;
  const svgPlay = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" width="22" height="22"><path stroke-linecap="round" stroke-linejoin="round" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112Z" /></svg>`;

  // Traccia i controller già inizializzati per evitare duplicati
  const initializedControllers = new Set();

  function attachVideoController(video, toggleBtn, toggleIcon) {
    if (!video || !toggleBtn || !toggleIcon) return;
    
    // Se questo controller è già stato inizializzato, saltalo
    const controllerId = toggleBtn.id;
    if (initializedControllers.has(controllerId)) return;
    initializedControllers.add(controllerId);
    
    function setPauseIcon() {
      toggleIcon.innerHTML = svgPause;
      toggleBtn.setAttribute('aria-label', 'Pausa video');
    }
    function setPlayIcon() {
      toggleIcon.innerHTML = svgPlay;
      toggleBtn.setAttribute('aria-label', 'Riproduci video');
    }
    
    // Rimuovi event listener esistenti prima di aggiungerne di nuovi
    const clickHandler = function() {
      if (video.paused) {
        let playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.then(_ => setPauseIcon())
            .catch(error => setPlayIcon());
        } else {
          setPauseIcon();
        }
      } else {
        video.pause();
        setPlayIcon();
      }
    };
    
    // Usa un approccio più efficiente con un listener singolo
    toggleBtn.addEventListener('click', clickHandler);
    
    // Assegna gli handler direttamente all'elemento per poterli rimuovere se necessario
    video._playHandler = setPauseIcon;
    video._pauseHandler = setPlayIcon;
    
    video.addEventListener('play', video._playHandler);
    video.addEventListener('pause', video._pauseHandler);
    
    // Stato iniziale
    if (video.paused) setPlayIcon();
    else setPauseIcon();
  }

  // Funzione per inizializzare tutti i controller video sulla pagina
  function initAllVideoControllers() {
    console.log('Inizializzazione controller video...');
    
    // 1. Cerca tutti i pulsanti con ID che inizia con "VideoToggleBtn-"
    document.querySelectorAll('[id^="VideoToggleBtn-"]').forEach(function(toggleBtn) {
      const btnId = toggleBtn.id;
      const blockId = btnId.replace('VideoToggleBtn-', '');
      const videoId = 'VideoBlock-' + blockId;
      const toggleIconId = 'VideoToggleIcon-' + blockId;
      
      const video = document.getElementById(videoId);
      const toggleIcon = document.getElementById(toggleIconId);
      
      if (video && toggleIcon) {
        attachVideoController(video, toggleBtn, toggleIcon);
      }
    });
    
    // 2. Supporto legacy per hero video banner (se presente)
    const heroVideo = document.getElementById('HeroVideoBannerVideo');
    const heroToggleBtn = document.getElementById('HeroVideoBannerToggle');
    const heroToggleIcon = document.getElementById('HeroVideoBannerToggleIcon');
    if (heroVideo && heroToggleBtn && heroToggleIcon) {
      attachVideoController(heroVideo, heroToggleBtn, heroToggleIcon);
    }
    
    // 3. Supporto legacy per split video (se presente)
    const splitVideo = document.getElementById('SplitLeftVideo');
    const splitToggleBtn = document.getElementById('SplitLeftVideoToggle');
    const splitToggleIcon = document.getElementById('SplitLeftVideoToggleIcon');
    if (splitVideo && splitToggleBtn && splitToggleIcon) {
      attachVideoController(splitVideo, splitToggleBtn, splitToggleIcon);
    }
  }
  
  // Inizializza tutti i controller video solo dopo che il DOM è completamente caricato
  initAllVideoControllers();
  
  // Usa un flag per limitare la frequenza delle chiamate di reinizializzazione
  let observerThrottled = false;
  
  // Osserva il DOM per nuovi video aggiunti dinamicamente, ma con ottimizzazioni
  const observer = new MutationObserver(function(mutations) {
    // Evita chiamate multiple ravvicinate
    if (observerThrottled) return;
    observerThrottled = true;
    
    setTimeout(function() {
      initAllVideoControllers();
      observerThrottled = false;
    }, 500); // Intervallo più lungo per evitare sovraccarichi
  });
  
  // Osserva solo le parti rilevanti del documento
  const relevantContainers = document.querySelectorAll('.section-hero-video-banner, .page-width');
  if (relevantContainers.length > 0) {
    relevantContainers.forEach(container => {
      observer.observe(container, {
        childList: true,
        subtree: true
      });
    });
  } else {
    // Fallback: osserva l'intero documento ma con configurazioni ottimizzate
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: false,
      characterData: false
    });
  }
});
